import { combineReducers } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import message from 'antd/lib/message';
import { t } from '../../../app/i18n';
import {
  createApiActionCreators,
  createActionCreator,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
  FAILURE,
} from '../../../common/utils/reduxHelpers';
import helpApi from '../api';
import { helpStatus } from '../../../common/enums';

/**
 * ACTION TYPES
 */
export const CREATE_QUESTION = 'help/CREATE_QUESTION';
export const FETCH_QUESTIONS = 'helpManagement/FETCH_QUESTIONS';
export const SET_QUESTIONS_PAGINATION = 'helpManagement/SET_QUESTIONS_PAGINATION';
export const SET_QUESTIONS_FILTER = 'helpManagement/SET_QUESTIONS_FILTER';
export const FETCH_QUESTION = 'helpManagement/FETCH_QUESTION';
export const UPDATE_QUESTION = 'helpManagement/UPDATE_QUESTION';
export const FETCH_QUESTION_COUNT = 'helpManagement/FETCH_QUESTION_COUNT';

/**
 * ACTIONS
 */
export const createQuestionActions = createApiActionCreators(CREATE_QUESTION);
export const fetchQuestionsActions = createApiActionCreators(FETCH_QUESTIONS);
export const setQuestionsPaginationAction = createActionCreator(SET_QUESTIONS_PAGINATION);
export const setQuestionsFilterAction = createActionCreator(SET_QUESTIONS_FILTER);
export const fetchQuestionActions = createApiActionCreators(FETCH_QUESTION);
export const updateQuestionActions = createApiActionCreators(UPDATE_QUESTION);
export const fetchQuestionCountActions = createApiActionCreators(FETCH_QUESTION_COUNT);

/**
 * REDUCERS
 */
const initialState = {
  question: null,
  questions: {
    items: [],
    pagination: {
      current: null,
      pageSize: null,
      total: null,
    },
    filter: {
      id_status: helpStatus.NEZODPOVEDANA,
    },
  },
  questionCount: null,
};


const question = createReducer(initialState.question, {
  [FETCH_QUESTION]: {
    [SUCCESS]: (state, payload) => payload,
    [FAILURE]: () => null
  },
  [UPDATE_QUESTION]: {
    [SUCCESS]: (state, payload) => payload,
  },
  [CREATE_QUESTION] : {
    [SUCCESS]: (state, payload) => payload
  },
  
});

const questions = createReducer(initialState.questions, {
  [FETCH_QUESTIONS]: {
    [SUCCESS]: (state, payload) => ({
      ...state,
      items: payload.data,
    }),
    [FAILURE]: state => ({
      ...state,
      items: [],
    }),
  },
  [SET_QUESTIONS_PAGINATION]: (state, payload) => ({
    ...state,
    pagination: {
      current: payload.pageNumber + 1,
      pageSize: payload.pageSize,
      total: payload.total,
    },
  }),
  [SET_QUESTIONS_FILTER]: (state, payload) => ({
    ...state,
    filter: payload,
  }),

});

const questionCount = createReducer(initialState.questionCount, {
  [FETCH_QUESTION_COUNT]: {
    [SUCCESS]: (state, payload) => payload,
    [FAILURE]: () => null
  },
})



export default combineReducers({
  question,
  questions,
  questionCount,
});

/**
 * SELECTORS
 */
export const selectQuestionState = state => state.question;
export const selectQuestion = state => selectQuestionState(state).question

export const selecQuestionsState = state => selectQuestionState(state).questions;
export const selectQuestions = state => selecQuestionsState(state).items;
export const selectQuestionPagination = state => selecQuestionsState(state).pagination;
export const selectQuestionFilter = state => selecQuestionsState(state).filter;

export const selectQuestionCount = state => selectQuestionState(state).questionCount;

/**
 * SAGAS
 */

function* createQuestion({ payload }){  
  const resp = yield call(helpApi.createQuestion, payload);
  if (resp.ok){
      yield put(createQuestionActions.success(resp.data));
      yield put(push(`/`))
      message.success(t('Otázka bola odoslaná'))

  }
  else{
      yield put(createQuestionActions.failure(resp.error));
      message.error(t('Nepodarilo sa odoslať otázku'))
  }

}


function* fetchQuestion ( payload ) {

  const resp = yield call(helpApi.fetchQuestion, payload.payload);

  if(resp.ok) {
    yield put(fetchQuestionActions.success(resp.data));
  }
  else{
    yield put(fetchQuestionActions.failure(resp.error));
  }
}

function* fetchQuestions({ payload }){

  const resp = yield call(helpApi.fetchQuestions, payload);
  if(resp.ok){
    yield put(fetchQuestionsActions.success(resp.data));
    yield put(setQuestionsPaginationAction(resp.data));
  }
  else {
    yield put(fetchQuestionsActions.failure(resp.error));
  }

}

function* updateQuestion({ payload }){

  const resp = yield call(helpApi.updateQuestion, payload)
  if(resp.ok){
    yield put(updateQuestionActions.success(resp.data))
    yield put(push(`/admin/help`))
    message.success(t('Odpoveď bola odoslaná'))
  }
  else{
    yield put(updateQuestionActions.failure(resp.data))
  }

}

function* fetchQuestionCount( {payload} ){
  const resp = yield call(helpApi.fetchQuestionCount, payload)
  if (resp.ok){
    yield put(fetchQuestionCountActions.success(resp.data))
  }
  else{
    yield put(fetchQuestionCountActions.failure(resp.error))
  }
}



export function* questionSaga() {
  yield takeLatest(createActionType(CREATE_QUESTION, REQUEST), createQuestion)
  yield takeLatest(createActionType(FETCH_QUESTION, REQUEST), fetchQuestion)
  yield takeLatest(createActionType(FETCH_QUESTIONS, REQUEST), fetchQuestions);
  yield takeLatest(SET_QUESTIONS_FILTER, fetchQuestions);
  yield takeLatest(createActionType(UPDATE_QUESTION, REQUEST), updateQuestion)
  yield takeLatest(createActionType(FETCH_QUESTION_COUNT, REQUEST), fetchQuestionCount);
}


// WEBPACK FOOTER //
// ./src/features/help-management/ducks/index.js